import React, { useEffect } from "react";
import useStyles from "../style";
import FormControl from "@material-ui/core/FormControl";
import { Controller } from "react-hook-form";
import { Switch } from "antd";
import { FormControlLabel } from "@material-ui/core";

function HideContractAddress(props: any) {
  const classes = useStyles();
  const { setValue, control, poolDetail } = props;

  useEffect(() => {
    if (poolDetail && poolDetail.hide_address) {
      setValue("hide_address", poolDetail.hide_address);
    }
  }, [poolDetail]);

  return (
    <>
      <div>
        <FormControl component="fieldset">
          <label className={classes.formControlLabel}>Hide Contract Address</label>

          <Controller
            control={control}
            rules={{}}
            name="hide_address"
            render={(field) => {
              const { value, onChange } = field;
              return (
                <FormControlLabel
                  control={
                    <Switch
                      onChange={(e) => {
                        const valueToSet = e ? 1 : 0;
                        setValue(field.name, valueToSet);
                        onChange(valueToSet);
                      }}
                      checked={!!value}
                      style={{marginLeft: "10px"}}
                    />
                  }
                  label=""
                />
              );
            }}
          />
        </FormControl>
      </div>
    </>
  );
}

export default HideContractAddress;
